<template>
  <div class="c-legend">
    <ul v-if="data && data.length > 0">
      <li
        v-for="(item, index) in data"
        :key="index"
      >
        <i :style="{ backgroundColor: getNextColor(index) }" />
        <div v-if="item.key || item.value">
          <span v-if="item.key">{{ item.key }}</span>
          <span v-if="item.value">{{ item.value }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import pastelRainbowColors from '../../mixins/pastelRainbowColors'

export default {
  name: 'CLegend',
  mixins: [pastelRainbowColors],
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-legend {
  ul {
    margin-bottom: 20px;
    padding: 0;
    list-style: none;
    & > li {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      padding: 8px 0;
      border-bottom: 1px #eee solid;
      &:last-child {
        margin-bottom: 0;
      }
      i {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        & + div {
          width: 100%;
          padding-left: 14px;
          font-size: 18px;
          & span {
            //display: inline-flex;
            //width: 50%;
            @media all and (max-width: $smBreakpoint) {
              font-size: 16px;
            }
            & + span {
              justify-content: right;
            }
          }
        }
      }
    }
  }
}
</style>
